export default __webpack_public_path__ + "static/media/qrCode.ac98667b.svg";